<template>
    <div class="site-footer">
        <BContainer>
            <BRow class="footer-main">
                <BCol cols="12" xl="3" class="order-1">
                    <div class="logo-container">
                        <img src="@/assets/images/logo_footer.svg" alt="Cosmoscow" class="logo" />
                        <span class="social-icons">
                            <a href="https://telegram.me/cosmoscowfair" target="_blank" class="social-icon">
                                <Icon name="bxl:telegram"/>
                            </a>
                            <a href="https://vk.com/cosmoscowfair" target="_blank" class="social-icon social-icon--vk">
                                <Icon name="simple-icons:vk"/>
                            </a>
                            <a href="https://www.youtube.com/channel/UCFKq0DWGwXylp6G_X3I_pLQ/videos?view_as=subscriber" target="_blank" class="social-icon">
                                <Icon name="bxl:youtube"/>
                            </a>
                        </span>
                    </div>
                    <div class="footer-newsletter">
                        <div class="footer-newsletter-title">
                            {{ t('Subscribe to Cosmoscow news') }}
                        </div>
                        <div>
                            <NewsSubscriptionInput class="footer-newsletter-input"/>
                        </div>
                    </div>
                    <div class="footer-divider d-xl-none"></div>
                </BCol>

                <BCol cols="12" xl="8" offset-xl="1" class="order-3 order-xl-2">
                    <BRow>
                        <BCol cols="12" lg="4">
                            <div class="footer-menu">
                                <div class="footer-menu-header">
                                    {{ t('For visitors') }}
                                </div>
                                <NuxtLink v-if="currentYear?.is_tickets_available === true" :to="localePath('/visitors/')">{{ t('Tickets') }}</NuxtLink>
                                <!-- 
                                <a href="#">{{ t('Visiting rules') }}</a>
                                <a href="#">{{ t('FAQ') }}</a> 
                                -->
                                <NuxtLink :to="localePath('/about/fair/')">{{ t('About fair') }}</NuxtLink>
                                <NuxtLink :to="localePath('/about/team/')">{{ t('Team') }}</NuxtLink>
                                <NuxtLink :to="localePath('/about/workwithus/')">{{ t('Volunteers') }}</NuxtLink>
                                <NuxtLink :to="localePath('/contacts/')">{{ t('Contacts') }}</NuxtLink>
                            </div>
                        </BCol>

                        <BCol cols="12" lg="4">
                            <div class="footer-menu">
                                <div class="footer-menu-header">
                                    {{ t('Policy') }}
                                </div>
                                <NuxtLink :to="localePath('/legal/privacy_policy/')">{{ t('Privacy Policy') }}</NuxtLink>
                                <NuxtLink :to="localePath('/legal/expert_reg/')">{{ t('Expert Council Regulations') }}</NuxtLink>
                            </div>
                        </BCol>

                        <BCol cols="12" lg="4">
                            <div class="footer-menu">
                                <div class="footer-menu-header">
                                    {{ t('Ecosystem') }}
                                </div>
                                <a href="https://foundation.cosmoscow.com" target="_blank">{{ t('Cosmoscow Foundation') }}</a>
                                <a href="https://artcollectors.cosmoscow.com" target="_blank">{{ t('Cosmoscow Collectors Club') }}</a>
                                <a href="https://teodorus.art/" target="_blank">{{ t('TEO by Cosmoscow') }}</a>
                                <a href="https://blazar.art/" target="_blank">{{ t('blazar') }}</a>
                                <a href="https://oberton.cosmoscow.com/" target="_blank">«{{ t('Oberton') }}»</a>
                            </div>
                        </BCol>
                    </BRow>
                    <div class="footer-divider d-xl-none"></div>
                </BCol>
            </BRow>

            <div class="footer-additional-info">
                <BRow>
                    <BCol cols="12" xl="4" class="footer-title">
                        {{ t('Cosmoscow Institutional Platform') }}
                    </BCol>
                    <BCol cols="12" xl="3" class="footer-address">
                        {{ t('119034, Russia, Moscow, Prechistensky Lane, 12 (entrance 2, floor 2)') }}
                    </BCol>
                    <BCol cols="12" xl="3" class="footer-contacts">
                        +7 (962) 993-61-33<br>
                        <a href="mailto:info@cosmoscow.com">info@cosmoscow.com</a>
                    </BCol>
                    <BCol cols="12" xl="2">
                        <div class="footer__payment-methods">
                            <Icon name="bxl:visa" class="footer__payment-methods-icon"/>
                            <Icon name="bxl:mastercard" class="footer__payment-methods-icon"/>
                            <img src="@/assets/images/mir-payment-card.svg" :alt="t('Mir')" class="footer__payment-methods-icon"/>
                        </div>
                    </BCol>
                </BRow>
            </div>
        </BContainer>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import NewsSubscriptionInput from '@/components/site/NewsSubscriptionInput.vue'
import { useLocalePath } from '#imports'

const { data: currentYear } = useFairYearCurrent()

const localePath = useLocalePath()

const { t } = useI18n({
    messages: {
        ru: {
            'Subscribe to Cosmoscow news': 'Новости Cosmoscow на вашей почте',
            'Enter your email': 'Введите ваш email',
            'For visitors': 'Посетителям',
            'Tickets': 'Билеты',
            'Visiting rules': 'Правила посещения',
            'FAQ': 'FAQ',
            'About fair': 'О ярмарке',
            'Team': 'Команда',
            'Contacts': 'Контакты',
            'Policy': 'Политика',
            'Privacy Policy': 'Политика конфиденциальности',
            'Expert Council Regulations': 'Регламент Экспертного Совета',
            'Ecosystem': 'Экосистема',
            'Cosmoscow Foundation': 'Фонд Cosmoscow',
            'Cosmoscow Collectors Club': 'Клуб Коллекционеров Cosmoscow',
            'TEO by Cosmoscow': 'TEO by Cosmoscow',
            'Oberton': 'Обертон',
            'blazar': 'blazar',
            'Cosmoscow Institutional Platform': 'Институциональная платформа Cosmoscow',
            '119034, Russia, Moscow, Prechistensky Lane, 12 (entrance 2, floor 2)': '119034, Россия, Москва, Пречистенский переулок, дом 12 (подъезд 2, этаж 2)',
            'Mir': 'Мир',
            'Volunteers': 'Волонтёрам'
        }
    }
})

defineOptions({
    name: 'SiteFooter'
})
</script>

<style lang="scss" scoped>
.site-footer {
    background-color: #444444;
    color: #5d5d5d;
    padding: 5rem 0;

    a {
        color: #5d5d5d;
        text-decoration: none;
    }
    
    @media (max-width: 1199px) {
        padding: 2rem 0;
    }

    .footer-divider {
        height: 1px;
        background-color: rgba(#767676, 0.8);
        margin: 2rem 0;
        width: 100%;
    }

    .logo-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2rem;
        
        .logo {
            height: 1.5rem;
        }
    }

    .footer-menu {
        margin-bottom: 2rem;

        @media (min-width: 1200px) {
            margin-bottom: 0;
            padding-right: 2rem;

            &:last-child {
                padding-right: 0;
            }
        }

        .footer-menu-header {
            font-weight: 600;
            margin-bottom: 1rem;
            color: #5d5d5d;
            font-size: 1rem;
        }

        a {
            display: block;
            color: #a7a7a7;
            text-decoration: none;
            margin-bottom: 0.5rem;
            font-size: 0.9rem;
            line-height: 1.4;
            
            &:hover {
                opacity: 0.8;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .footer-newsletter {
        margin-bottom: 2rem;

        @media (min-width: 1200px) {
            margin-bottom: 0;
        }

        .footer-newsletter-title {
            font-size: 1rem;
            font-weight: 500;
            color: #a7a7a7;
            margin-bottom: 0.7rem;
        }

        .footer-newsletter-input {
            :deep(.b-input-group),
            :deep(.input-group) {
                border-radius: 0.5rem;
                overflow: hidden;
                background: none;
            }

            :deep(.b-form-input),
            :deep(.form-control) {
                background-color: #4a4a4a;
                border-color: #4a4a4a;
                color: #a7a7a7;
                font-size: 0.95rem;
                font-family: inherit;
                font-weight: 400;
                height: 2.25rem;
                border-radius: 0.375rem 0 0 0.375rem !important;
                padding: 0 1rem;
                &::placeholder {
                    color: #a7a7a7;
                    opacity: 1;
                    font-size: 0.95rem;
                    font-family: inherit;
                    font-weight: 400;
                }
            }

            :deep(.b-input-group-append .b-button),
            :deep(.input-group-append .btn),
            :deep(.b-button),
            :deep(.btn) {
                background-color: #a7a7a7;
                border-color: #a7a7a7;
                color: #444444 !important;
                font-size: 1.1rem;
                border-radius: 0 0.375rem 0.375rem 0 !important;
                height: 2.25rem;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 1rem;
                font-family: inherit;
                font-weight: 400;
            }
        }
    }

    .footer-additional-info {
        margin-top: 5rem;
        font-size: 0.9rem;
        font-weight: normal;
        color: #767676;
        line-height: 1.4;

        @media (max-width: 1199px) {
            margin-top: 2rem;
            
            .footer-title,
            .footer-address,
            .footer-contacts {
                margin-bottom: 1rem;
            }
        }

        .footer__payment-methods {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 1rem;

            @media (max-width: 1199px) {
                justify-content: flex-start;
                margin-top: 1.5rem;
            }

            &-icon {
                height: 2.5rem;
                width: 2.5rem;
                color: #767676;
                display: flex;
                align-items: center;

                &[src] {
                    height: 0.9rem;
                    width: auto;
                }

                @media (max-width: 1199px) {
                    height: 2rem;
                    width: 2rem;

                    &[src] {
                        height: 0.8rem;
                    }
                }
            }
        }
    }

    .social-icons {
        margin-left: 2rem;
        display: flex;
        gap: 0.5rem;
        margin-top: 0;

        .social-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 1.5rem;
            height: 1.5rem;
            background-color: #a7a7a7;
            color: #444444;
            text-decoration: none;
            border-radius: 50%;
            font-size: 1rem;
            transition: opacity 0.2s ease;

            &:hover {
                opacity: 0.8;
            }
        }

        .social-icon--vk {
            background-color: transparent;
            color: #a7a7a7;
            overflow: visible;
            font-size: 1.85rem;

            :deep(.iconify) {
                width: 1em;
                height: 1em;
            }
        }
    }
}
</style>

